import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from '@sdbn/appclient';
import { ServiceResponse } from '@sdbn/appclient';
import { environment } from 'src/environments/environment';
import { Station, SaveMapConfiguration, SaveMapConfigurationResponse, MapConfiguration } from './yard-map-configuration-model';

@Injectable({
  providedIn: 'root'
})
export class YardMapConfigurationService {

  constructor(private httpService: HttpService) {
  }

  public loadMapConfigurations(): Observable<Array<MapConfiguration>> {
    return this.httpService.postWithContext<Array<MapConfiguration>>(environment.yardMapAdminEndpoint + '/configurations', {});
  }

  public getStations(): Observable<Array<Station>> {
    return this.httpService.postWithContext<Array<Station>>(environment.yardMapAdminEndpoint + '/stations', {});
  }

  public loadMapConfiguration(configurationId: number): Observable<any> {
    return this.httpService.postWithContext<any>(environment.yardMapAdminEndpoint + '/details', configurationId);
  }

  public deleteMapConfiguration(configurationId: number): Observable<ServiceResponse> {
    return this.httpService.postWithContext<ServiceResponse>(environment.yardMapAdminEndpoint + '/delete', configurationId);
  }

  public saveMapConfiguration(request: SaveMapConfiguration): Observable<SaveMapConfigurationResponse> {
    return this.httpService.postWithContext<SaveMapConfigurationResponse>(environment.yardMapAdminEndpoint + '/save', request);
  }

}
